import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { ApiService } from 'src/app/services/api/api.service';
import { Events } from 'src/app/services/events';
import { LoginPage } from '../login/login.page';
import { SignupPage } from '../signup/signup.page';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.page.html',
  styleUrls: ['./terms-of-service.page.scss'],
})
export class TermsOfServicePage implements OnInit {

  isLogin = false;
  user_id: any;
  profile_pic: any;
  profile_picData: any;
  user: any;
  auth: any;
  userData: any;
  isDesktop: any;
  isMobile: any;
  isModal: boolean;
  fromWhere: string;

  constructor(private router: Router, private navCtrl: NavController,
    private modalController: ModalController,
    private apiService: ApiService,
    private platform: Platform,
    private events: Events,
    private util: UtilService,
    private store: Store<any>,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.fromWhere = params.fromWhere;
    });
  }

  ionViewWillEnter() {
    this.getData();
  }

  getData() {
    let platform = this.platform.platforms();
    this.isMobile = platform.includes('mobile');
    this.isDesktop = platform.includes('desktop');

    if (this.isDesktop) {
      this.apiService.setSplitPane(true);
    }

    this.store.select<any>('auth').subscribe(state => this.auth = state);
    this.store.select<any>('user').subscribe(state => this.userData = state);

    if (this.auth && this.auth?.authenticationData != null && this.userData && Object.keys(this.userData).length != 0 && Object.keys(this.auth).length != 0) {
      this.isLogin = this.auth?.authenticationData?.login;
      this.user = this.userData?.user;
      this.user_id = this.user?.userID;
      this.profile_picData = this.userData?.user?.profile_pic;
      this.profile_pic = this.apiService.imageUrl + this.userData?.user?.profile_pic;
      this.events.publish('loginn', {
        login: true,
      });
      if (this.isDesktop) {
        this.apiService.setSplitPane(true);
      }
    } else {
      this.isLogin = false;
      this.apiService.setSplitPane(false);
    }
  }

  logout() {
    this.events.publish("profileClicked");
    this.router.navigate(['/tabs/profile-new'])
  }

  home() {
    this.navCtrl.navigateRoot(['/home']);
  }

  goBack() {
    if (this.isModal) {
      this.modalController.dismiss();
    } else if (!this.isMobile && this.fromWhere === 'helpSupport') {
      this.router.navigate(['/tabs/profile-new'], { queryParams: { fromWhere: 'helpSupport' } });
    } else {
      this.navCtrl.back();
    }
  }

  async login() {
    const modal = await this.modalController.create({
      component: LoginPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  async signup() {
    const modal = await this.modalController.create({
      component: SignupPage,
      cssClass: 'modal_login',
      backdropDismiss: false
    });
    return await modal.present();
  }

  faq() {
    this.router.navigate(['/faq']);
  }

  privacyPolicy() {
    const queryParams = this.fromWhere ? { fromWhere: this.fromWhere } : {};
    this.router.navigate(['/privacy-policy'], { queryParams });
  }

  smsConsent() {
    this.router.navigate(['/sms-consent']);
  }

  howDoesItWork() {
    this.router.navigate(['/how-does-it-work']);
  }

  goToChat() {
    this.router.navigate(['/tabs/chat'])
  }

}
